/* global Search */

var MobileGeneric = function() {
    return {
        updateUnreadCounter: function() {
            Ajax.getUserData((res) => {
                if (parseInt(res.msg_count) != 0) {
                    $('.ii__unread_cnt').html(res.msg_count);
                    $('.ii__unread_cnt').show();
                    $('.ii__chat_cnt').hide();
                } else {
                    $('.ii__unread_cnt').hide();
                    $('.ii__chat_cnt').show();
                }
            }).finally(function() {
                setTimeout(MobileGeneric.updateUnreadCounter, 30 * 1000);
            });
        },
        closePopovers: function(except) {
            Search.resetSearch(false);

            if (except != 'menu') {
                $('body').removeClass('menu-on');
            }
            if (except != 'companies') {
                $('#drop_companies').removeClass('show');
                $('.ii_show_companies').removeClass('active');
                $('body').removeClass('preventscroll');
            }
            if (except != 'profile') {
                $('#drop_profile').removeClass('show');
                $('.ii_show_profile').removeClass('active');
            }
        },
        desktopRedirect: function(url) {
            let isMobile = navigator.userAgent.toLowerCase().indexOf('mobile') != -1 &&
                           navigator.userAgent.indexOf('iPad') == -1;
            if (window.cookieconsent && !isMobile) {
                // see assets/css/cookieconsent.min.css for extra styling
                window.cookieconsent.initialise({
                    'palette': {
                        'popup': {
                            'background': '#1F2126',
                            'text': '#ffffff'
                        }
                    },
                    'content': {
                        'message': 'Αυτή η σελίδα υπάρχει και σε desktop έκδοση.',
                        'link': 'Δείτε την σε πλήρη ανάλυση',
                        'href': url,
                        'target': '_self',
                        'dismiss': 'Μην ξαναρωτηθώ'
                    },
                    'cookie': {
                        'name': 'desktop_redirect',
                        'expiryDays': 2
                    }
                });
            }
        },
        showAppPromo: function(url) {
            if (Generic.visitCount < 2 || Generic.jsCookies.hasItem('APP_PROMO')) {
                return;
            }
            Generic.jsCookies.setItem('APP_PROMO', '1', 3600 * 24 * 365, '/');
            var appPromoHtml =
                `<div class="modal fade" id="apppromo-modal" tabindex="-1" role="dialog" aria-labelledby="login_modal_label" aria-hidden="true">
                     <div class="modal-dialog">
                         <div class="modal-content new-modal-content">
                             <div class="modal-header">
                                 <h4 class="modal-title" id="login_modal_label">
                                     Δοκιμάστε την επίσημη εφαρμογή του Agones.gr
                                 </h4>
                             </div>
                             <div class="modal-body">
                             <div class="row">
                                 <div class="col-12 d-flex" style="justify-content: flex-end;">
                                     <a href="` + url + `" rel="nofollow noopener" class="btn btn-primary-new btn--big">Άνοιγμα</a>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>`;
            $('body').append(appPromoHtml);
            $('#apppromo-modal').modal();
        },
        init: function() {
            MobileGeneric.sticky_footer_visible = true;
            $('.ii__show_menu').click(function() {
                // run critical part ASAP
                $('body').toggleClass('menu-on');
                // run non-critical part in a delayed fashion #INP_optimization
                setTimeout(function() {
                    MobileGeneric.closePopovers('menu');
                    if ($('body').hasClass('menu-on')) {
                        ActionTracker.record('menu-open-mobile');
                    } else {
                        $('.ii__menu_content').scrollTop(0);
                    }
                });
            });
            if ($('.ii_show_companies').length > 0) {
                $('.ii_show_companies').click(function() {
                    $(this).toggleClass('active');
                    MobileGeneric.closePopovers('companies');
                    $('#drop_companies').toggleClass('show');
                    $('body').toggleClass('preventscroll');
                });
            }
            $('.ii_show_profile').click(function() {
                $(this).toggleClass('active');
                MobileGeneric.closePopovers('profile');
                $('#drop_profile').toggleClass('show');
            });

            $('.ii__mobile_off').click(function() {
                MobileGeneric.switchMobileOff($(this).data('url'));
            });
            // Mobile height (needed for overlay height adjusting)
            window.addEventListener('load', function() {
                var vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', vh + 'px');
            });
            window.addEventListener('resize', function() {
                var vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', vh + 'px');
            });
            if (Generic.loggedin) {
                setTimeout(MobileGeneric.updateUnreadCounter, 30 * 1000);
            }
            Generic.jsCookies.setItem('mobile', 'yes', 1, '/');  // cancel any existing mobile=no override
        },
        saveOddsCompany: function(odds_company_id, match_id) {
            if (window.location.pathname.indexOf('/livescore/') === -1) {
                MobileHomepage.saveOddsCompany(odds_company_id, match_id);
            } else {
                MobileMatch.saveOddsCompany(odds_company_id);
            }
        },
        switchMobileOff: function(url) {
            Generic.jsCookies.setItem('mobile', 'no', 3600 * 24 * 365, '/');
            top.location.href = url;
        },
        initMatchArticleTabTrigger: function() {
            $(document).on('shown.bs.tab', '.ii__match_article', function(e) {
                if ($(e.target).hasClass('ii__match_article')) {
                    $('#matchtapb-' + $(this).data('mid')).hide();
                }
            });
            $(document).on('hidden.bs.tab', '.ii__match_article',  function(e) {
                if ($(e.target).hasClass('ii__match_article')) {
                    $('#matchtapb-' + $(this).data('mid')).show();
                }
            });
        },
        showVideo: function(glomex_id) {
            var src = '<div class="w-100"><glomex-player data-integration-id="40599z13k6s8fl1f" data-playlist-id="' + glomex_id + '"></glomex-player></div>';
            Generic.alert('Video', src, true);
        },
        initMatchHistory: function(homepage) {
            if (homepage) {
                // remove history overlay+content from DOM
                // we remove them when we close the match popover but this may be a match reload
                $('#main_content > .ii__history').remove();
                $('#main_content > .ii__history_overlay').remove();
                // move match history overlay and content under main_content
                // this is needed to move it out of the match popver overlay
                // because overlay inside overlay causes many problems with scrolling
                $('.ii__history').detach().appendTo('#main_content');
                $('.ii__history_overlay').detach().appendTo('#main_content');
            }

            $('.ii__history_trigger').click(function() {
                $('.page').addClass('history-on');
                if (!homepage) {
                    $('.ii__sticky_footer').hide();
                    MobileGeneric.sticky_footer_visible = false;
                }
            });
            $('.ii__history_close, .ii__history_overlay').click(function() {
                $('.page').removeClass('history-on');
                if (!homepage) {
                    $('.ii__sticky_footer').show();
                    MobileGeneric.sticky_footer_visible = true;
                }
            });
            $('.ii__history_match').click(function() {
                top.location.href = $(this).data('link');
            });
        },
        initMoreAnalyseis: function() {
            // initial button state
            $('.ii__trigger_analyseis').hide();

            // if opened match has no 'Ανάλυση' don't show 'Περισσότερες Αναλύσεις'
            if ($('#main_content [data-tabname=analysi]').length > 0) {
                if ($('#main_content [data-tabname=analysi]').hasClass('active')) {
                    $('.ii__trigger_analyseis').show();
                }

                $('.ii__trigger_analyseis').on('click', function(e) {
                    const target = $(this).data('analyseis');
                    $(target).addClass('show');
                    $('.page').addClass('analyseis-on');
                    $('.ii__sticky_footer').hide();
                    MobileGeneric.sticky_footer_visible = false;
                });
                $('.ii__history_close, .ii__history_overlay').click(function() {
                    $('.page').removeClass('analyseis-on');
                    $('.ii__sticky_footer').show();
                    MobileGeneric.sticky_footer_visible = true;
                });
            }
        }
    };
}();
